import { gql } from "./gql";

export const ViewHivesQuery = gql(`query ViewHivesQuery { viewHives { __typename hiveId apiaryName hiveNumber queenYear colonyStrain url } }`);
export const RegisterHiveMutation = gql(`mutation RegisterHiveMutation($input: RegisterHiveInput!) { registerHive(input: $input) { __typename success error { __typename type message } } }`);
